import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/A9Service';
import { RsCustomerEmail } from 'common/customers/services/types/RsCustomerEmail';
import { CustomerEmailAdd } from 'common/customers/services/types/CustomerEmailAdd';
import { CustomerEmailPatch } from 'common/customers/services/types/CustomerEmailPatch';
import { RsCustomerEmailInfo } from 'common/customers/services/types/RsCustomerEmailInfo';
import { CustomerEmailUpdate } from 'common/customers/services/types/CustomerEmailUpdate';
import { EmailSendParams } from 'common/customers/services/types/EmailSendParams';

export interface ICustomerEmailDataProvider
    extends IDataProviderV2<RsCustomerEmail, RsCustomerEmailInfo, CustomerEmailAdd, CustomerEmailUpdate, CustomerEmailPatch> {
    getMain: (number) => Promise<RsCustomerEmail>;
}

@A9Service('customerEmailDataProvider')
export class CustomerEmailDataProvider
    extends AbstractDataProviderV2<RsCustomerEmail, RsCustomerEmailInfo, CustomerEmailAdd, CustomerEmailUpdate, CustomerEmailPatch>
    implements ICustomerEmailDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/emails');
    }

    public getMain(customerId: number) {
        return this.all({}, { customerId: customerId }).then(items => {
            return items.find(item => item.active && item.main);
        });
    }

    public sendFile(params: { customerId: number; fileId: number }, data: EmailSendParams, cancel: Promise<void> = null): Promise<{ id: number }> {
        const url = this.helper.buildUrl(this.apiUrl + '/file/{fileId}', params);
        return this.service.updateRequest<{ id: number }>(url, this.addMethod, data, null, cancel);
    }
}
